import { useState, useContext } from "react"
import { useParams } from "react-router-dom"
import { gql, useQuery } from "@apollo/client"

import { Field, useFormikContext } from "formik"

import { MultiSelect } from "primereact/multiselect"
import { FormContext } from "../../../context/formContext"
import { UserContext } from "../../../context/userContext"

import styles from "../../../styles/Form.module.css"

export default function MultiProgramsIdsByLocation({ field, block, index }) {
  const { idStamp } = useParams()

  const [programList, setProgramList] = useState([])
  const [visible, setVisible] = useState("block")
  const checkIfRequired = () => {
    try {
      return JSON.parse(field.field_validation.required[0])
    } catch (error) {
      return false
    }
  }
  const isRequired = checkIfRequired()
  const formik = useFormikContext()
  const form = useContext(FormContext)
  const userCtx = useContext(UserContext)
  let isDisabled = form ? form.blocksSaved[block] : false
  isDisabled = field.read_only ? true : isDisabled

  const GET_PROGRAMS = gql`
    query Programs($staff_id: ID!, $location_id: ID!, $organization_id: ID!) {
      programs: getActivePrograms(
        staff_id: $staff_id
        organization_id: $organization_id
      ) {
        key: program_identity_id
        label: program_id_name
      }
      programsSelected: programsByLocation(
        staff_id: $staff_id
        location_id: $location_id
      ) {
        key: program_identity_id
        label: program_id_name
      }
    }
  `
  const { loading } = useQuery(GET_PROGRAMS, {
    fetchPolicy: "network-only",
    variables: {
      staff_id: userCtx.session.user.staff_id,
      organization_id: userCtx.session.user.organization_id,
      location_id: idStamp || "",
    },
    onCompleted: ({ programs, programsSelected }) => {
      setProgramList(programs)
      formik.setFieldValue(field.field_name, programsSelected)
    },
    skip: !userCtx,
  })

  const handleSelectProgramIds = ({ e, form }) => {
    if (e.value === null) {
      form.setFieldValue(field.field_name, "")
    } else {
      form.setFieldValue(field.field_name, e.value)
    }
  }

  if (loading) return null

  return (
    <div
      className={styles.field}
      style={{
        order: index,
        display: visible,
      }}
    >
      <label className={styles.label}>
        {field.field_label}
        {isRequired && <span className={styles.asterisk}> *</span>}
      </label>
      {field.field_description && (
        <div className={styles.description}>{field.field_description}</div>
      )}
      <Field name={field.field_name}>
        {({ field: formikField, meta, form }) => (
          <>
            <MultiSelect
              placeholder="Please select"
              id={field.field_name}
              name={formikField.name}
              value={formikField.value}
              onChange={(e) => handleSelectProgramIds({ e, form })}
              disabled={isDisabled}
              options={programList}
              filter={false}
              display="chip"
            />
            {meta.touched && meta.error && (
              <div className={styles.errFieldMsg}>{meta.error}</div>
            )}
          </>
        )}
      </Field>
    </div>
  )
}
